import * as React from "react"
import { ChangeEvent } from "react" 
import { HabitPrescriptionItemRequest } from "@curefit/gmf-common";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import * as _ from "lodash";
import {TypeAheadElement} from "../TypeAhead";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import ModelFactory from "../../models/ModelFactory";
import DurationComponent from "../DurationComponent";
import CustomSelect from "../CustomSelect";
import IStaticData from "../../models/staticData/IStaticData";
import * as $ from "jquery";
import AppUtils from "../../utils/AppUtils";
import TextAreaAutoResize from "../TextAreaAutoResize";
import {IHabitListItem} from "../../models/LCPlanClientModels";

/**
 * Created by aditya on 28/06/18.
 */

export interface HabitsPlanItemEditorProps {
    consultationType?: string,
    item: IHabitListItem;
    onDataChange: (update: any) => any,
    staticLifestyleHabits: IStaticData,
    fetchFitnessActivities?: (input: string) => Promise<any>;
}

export interface HabitsPlanItemEditorState {
    validate: boolean;
}

class HabitsPlanItemEditor extends React.Component<HabitsPlanItemEditorProps, HabitsPlanItemEditorState> {
    private habitsPlanItemDOM: any;
    constructor(props: HabitsPlanItemEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.habitsPlanItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.habitsPlanItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onHabitCommentChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        let updatedActivity = { ...this.props.item, advice: event.target.value }
        this.props.onDataChange(updatedActivity);
    };

    onFitnessPlanReminderChange = (event: ChangeEvent<HTMLInputElement>) => {
        const updatedActivity = { ...this.props.item, reminder: event.target.checked }
        this.props.onDataChange(updatedActivity);
    }

    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }

    updateLifestyleHabitItemName = (item: string) => {
        let updatedActivity = { ...this.props.item, dailyHabit: {displayValue: this.getSelectedDisplayValue(item), internalValue: item} }
        this.props.onDataChange(updatedActivity);
    }

    onFrequencyChange = (elem: TypeAheadElement) => {
        let fitnessActivityFrequency = { ...elem.others.value };
        if (!_.isEmpty(fitnessActivityFrequency)) {
            let updatedActivity = { ...this.props.item, frequency: fitnessActivityFrequency }
            this.props.onDataChange(updatedActivity);
        }
    }

    getSelectedDisplayValue = (key: string) => {
        let index = this.props.staticLifestyleHabits.values.map(item => item.internalValue).indexOf(key);
        if (index !== -1) {
            return this.props.staticLifestyleHabits.values[index].displayValue;
        } else {
            return "";
        }
    }

    render() {
        const hasItem = !_.isEmpty(this.props.item);
        // let isCancelled = !_.isEmpty(this.props.item) && this.props.item.status === AppConstants.planStatus.CANCELLED;
        // let isEditable = _.isEmpty(this.props.item._id);
        let lifestyleHabitsList = !_.isEmpty(this.props.staticLifestyleHabits) ? this.props.staticLifestyleHabits.values : [];
        let lifestyleAdviceItem = hasItem && !_.isEmpty(this.props.item.dailyHabit) ? this.props.item.dailyHabit.displayValue : null;
        const hasFrequency = hasItem && !_.isEmpty(this.props.item.frequency);
        let frequencyUnit = hasFrequency ? this.props.item.frequency.unit : null;
        let frequencyCount = hasFrequency ? this.props.item.frequency.count : null;
        let habitComment = hasItem && !_.isEmpty(this.props.item.advice) ? this.props.item.advice : null;
        // let habitsNameValidationStatus = this.state.validate && _.isEmpty(lifestyleAdviceItem) ? "error" : "";
        const reminderValue = hasItem && AppUtils.isDefined(this.props.item.reminder) ? this.props.item.reminder : false;
        // const hasExpired = AppUtils.isExpiredPLI(this.props.item);
        // const expiredCls = hasExpired ? "expired-item" : "";
        return (
            <div className={`habits-plan-item-editor`} ref={(habitsPlanItemDOM) => this.habitsPlanItemDOM = habitsPlanItemDOM}>
                {/*{hasExpired && <div className={"expired-text"}>*/}
                    {/*<span>EXPIRED</span>*/}
                {/*</div>}*/}
                <div className={`smart-column habits-plan-item-editor-dailyHabit`}>
                    <CustomSelect dropdownValues={lifestyleHabitsList} selectedValue={lifestyleAdviceItem} defaultValue={"Select"} updateDropdownValue={this.updateLifestyleHabitItemName}/>
                </div>
                <div className="smart-column habits-plan-item-editor-frequency">
                    <DurationComponent isFrequency={true} unit={frequencyUnit}
                                       count={frequencyCount} dropdownItems={this.generateFrequencyListItems()} rootClass={"fitness-plan-frequency"} onDurationChange={this.onFrequencyChange} />
                </div>
                <div className="smart-column habits-plan-item-editor-condition">
                    <TextAreaAutoResize
                        name={"habits-plan-item-editor-condition"}
                        className={"textarea-input form-control"}
                        value={habitComment}
                        placeholder={AppPlaceholders.HABIT_EDITVIEW_THEME}
                        onChange={this.onHabitCommentChange}
                        rows={2}
                    />
                </div>
                <div className="smart-column habits-plan-item-editor-reminder">
                    <input type="checkbox" onChange={this.onFitnessPlanReminderChange} checked={reminderValue} />
                </div>
            </div>
        )
    }
}

export default HabitsPlanItemEditor;